module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product18-eedecd3567769c60988854a725160d37.jpg";